import { combineReducers } from 'redux';

import { infoAppReducer } from "./link-app"
import { getAppListsReducer } from "./app-list"
import { getConfigReducer } from "./app-config"
import { getGateConfigReducer } from "./gate-config"

import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";



const appPesistConfig = {
    key: 'app.info',
    storage: storage,
    whitelist: ['gate', 'appid', 'apkUrl']
}


export default combineReducers({
    info: persistReducer(appPesistConfig, infoAppReducer),
    config: getConfigReducer,
    gate: getGateConfigReducer,
    lists: getAppListsReducer
});
